import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import { IDownloads } from "@Models/IDownloads";

class DownloadsService extends ServiceBase {
    /**
     * Get all downloads listed in the CDN.
     */
    public async getAll(): Promise<Result<IDownloads>> {
        return await this.requestJson({
            originUrl: "https://cdn.totum.surgery",
            url: "/downloads/applications.json",
            headers: {
                "Cache-Control": "no-cache",
                Expires: "0",
                Pragma: "no-cache",
            },
            method: "GET",
        });
    }
}

export default DownloadsService;
